import { SensorRecord } from "@fly-workspace/lib-api-interface";

export const getSensorValue = (record?: SensorRecord | null): string =>
  record && record.value ? String(record.value) : "N/A";

export const getSensorDate = (record?: SensorRecord | null): string =>
  record && record.date ? record.date : "N/A";
